import { render, staticRenderFns } from "./payment-form.vue?vue&type=template&id=50ddca64&"
import script from "./payment-form.vue?vue&type=script&lang=js&"
export * from "./payment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports